/** 所属テナントを持たないユーザーの着地点。ホストはテナント管理へ送るため通らない */
export const NoTenant = () => {
  return (
    <div className="grid place-content-center px-6 py-24 text-center">
      <h1 className="text-XLarge font-bold text-gray-600">
        表示できるテナントがありません
      </h1>
      <p className="mt-2 text-Medium text-gray-500">
        管理者に招待を依頼してください。
      </p>
    </div>
  );
};
